/* (a)/(b) display helpers. Pure, so the rounding the page shows is tested
 * rather than eyeballed — "96.6%" against the loader's printout is the whole
 * point of the page. */

import type { AccuracyTotals } from "../api/types";

/** "96.6%", or an en dash when there is nothing to divide by. */
export function pct(v: number | null | undefined): string {
  return v == null || Number.isNaN(v) ? "–" : `${v.toFixed(1)}%`;
}

/** "27 wrong of 842 approved" — over the approved sub-tasks that have a ground
 *  truth (the (a) denominator); wrong can be fractional (an ambiguous row counts
 *  half). Approved sub-tasks with no GT event are named, never folded in. */
export function wrongOf(t: AccuracyTotals): string {
  const w = Number.isInteger(t.wrong) ? String(t.wrong) : t.wrong.toFixed(1);
  const extra = t.approved_no_gt > 0 ? ` (+${t.approved_no_gt} with no GT, not scored)` : "";
  return `${w} wrong of ${t.approved_scored} approved${extra}`;
}

/** "313 of 1,158 to the crowd". */
export function crowdOf(t: AccuracyTotals): string {
  return `${(t.subtasks - t.approved).toLocaleString("en-US")} of ${t.subtasks.toLocaleString("en-US")} to the crowd`;
}

/** Tone for (a) against the 95% goal, and (b) against the 10% goal. */
export function aTone(v: number | null): "good" | "near" | "bad" | "none" {
  if (v == null) return "none";
  return v >= 95 ? "good" : v >= 90 ? "near" : "bad";
}
export function bTone(v: number | null): "good" | "near" | "bad" | "none" {
  if (v == null) return "none";
  return v <= 10 ? "good" : v <= 25 ? "near" : "bad";
}
